import { MARQUEE_ITEMS } from "@/lib/site";

export default function Marquee() {
  const items = MARQUEE_ITEMS.map((item) => (
    <span key={item} className="flex items-center gap-6 pr-6">
      <span className="font-display text-2xl font-bold uppercase tracking-wide text-white/90 sm:text-3xl">
        {item}
      </span>
      <span aria-hidden="true" className="font-mono text-lg font-bold text-neon">//</span>
    </span>
  ));

  return (
    <div className="relative overflow-hidden border-y border-line bg-ink py-6" aria-label="Points forts MAXREVIX">
      <div className="flex w-max animate-marquee will-change-transform">
        <div className="flex">{items}</div>
        <div className="flex" aria-hidden="true">{items}</div>
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-night to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-night to-transparent" />
    </div>
  );
}
